import { gql } from '@apollo/client';
export {
    LIST_COMMON_CONFIGS_BY_CONFIG_KEY,
    CREATE_COMMON_CONFIG,
    UPDATE_COMMON_CONFIG,
    BATCH_DELETE_COMMON_CONFIGS,
    BATCH_UPDATE_COMMON_CONFIG_STATUS,
} from '../../../config/common-config/graphql/commonConfigQueries';
export type {
    CommonConfigType,
    ListCommonConfigsByConfigKeyResponse,
    ListCommonConfigsByConfigKeyVariables,
} from '../../../config/common-config/graphql/commonConfigQueries';

export const UPLOAD_ACTIVITY_ICON = gql`
    mutation UploadActivityIcon($input: UploadActivityIconInput!) {
        uploadActivityIcon(input: $input) {
            objectKey
            publicUrl
        }
    }
`;

export interface UploadActivityIconInput {
    fileBase64: string;
    filename: string;
    contentType: string;
}

export interface ActivityIconUploadType {
    objectKey: string;
    publicUrl: string;
}

export interface UploadActivityIconResponse {
    uploadActivityIcon: ActivityIconUploadType;
}
